<template>
  <div ref="mediaFormatDropdownButtonGroup" class="btn-group btn-group-sm bs3-margin-bottom3 bs3-margin-left">
    <button ref="mediaFormatDropdownButton" class="btn btn-default btn-sm dropdown-toggle" type="button" data-toggle="dropdown"
            aria-haspopup="true" aria-expanded="true">
      <i class="fa-light fa-plus"></i> Add <span class="caret"></span>
    </button>
    <div ref="mediaFormatDropdownMenu" id="mediaFormatDropdownMenu" class="dropdown-menu bs3-padding-reset" @keypress.enter.prevent="onEnter" style="max-height: calc(65vh);">
      <div class="panel panel-default bs3-margin-bottom-reset" style="border: none; box-shadow: none;">
        <div class="panel-body bs3-padding-y-reset" style="height: calc(65vh - 60px); width: 70vw;">
          <div class="row ">
            <div class="col-xs-3 scroll-y col-separator-right" style="height: calc(65vh - 60px);">
              <div class="bs3-padding-y">
                <form>
                  <!--
                   - SEARCH
                   -->
                  <div class="form-group">
                    <label for="search">Search:</label>
                    <input ref="search" type="text" class="form-control" id="search" v-model="search">
                  </div>
                  <!--
                   - MEDIA CATEGORY
                   -->
                  <media-category-select
                      v-model="mediaCategoryIds"
                      :p-currencies="pCurrencies"
                      :p-language="pLanguage"
                      :p-dictionary="pDictionary"
                      :p-urls="pUrls"
                      :p-error-list="pErrorList"
                      :p-src="pSrc"
                      :p-src-id="pSrcId"
                      p-input-name="dataForm.data.mediaCategoryIds"
                      p-error-key="dataForm.data.mediaCategoryIds"
                      p-select-container="#mediaCategoryDropdownMenu"
                      :p-required="false"
                      :p-disabled="false">
                  </media-category-select>
                  <!--
                  - MEDIA EXTRA INFO 1 SELECT (If enabled)
                  -->
                  <media-extra-info-select
                    v-if="pMediaExtraInfo1Enabled"
                    v-model="mediaExtraInfo1Values"
                    :p-currencies="pCurrencies"
                    :p-language="pLanguage"
                    :p-dictionary="pDictionary"
                    :p-urls="pUrls"
                    :p-error-list="pErrorList"
                    :p-src="pSrc"
                    :p-src-id="pSrcId"
                    p-input-name="dataForm.data.mediaExtraInfo1"
                    p-error-key="dataForm.data.mediaExtraInfo1"
                    p-select-container="#mediaExtraInfo1DropdownMenu"
                    :p-required="false"
                    :p-disabled="false"
                    :p-media-extra-info-index="1">
                  </media-extra-info-select>
                  <!--
                   - MEDIA EXTRA INFO 2 SELECT (If enabled)
                   -->
                  <media-extra-info-select
                      v-if="pMediaExtraInfo2Enabled"
                      v-model="mediaExtraInfo2Values"
                      :p-currencies="pCurrencies"
                      :p-language="pLanguage"
                      :p-dictionary="pDictionary"
                      :p-urls="pUrls"
                      :p-error-list="pErrorList"
                      :p-src="pSrc"
                      :p-src-id="pSrcId"
                      p-input-name="dataForm.data.mediaExtraInfo2"
                      p-error-key="dataForm.data.mediaExtraInfo2"
                      p-select-container="#mediaExtraInfo2DropdownMenu"
                      :p-required="false"
                      :p-disabled="false"
                      :p-media-extra-info-index="2">
                  </media-extra-info-select>
                  <!--
                   - MARKETS
                   -->
                  <market-select
                      v-model="marketIds"
                      :p-currencies="pCurrencies"
                      :p-language="pLanguage"
                      :p-dictionary="pDictionary"
                      :p-urls="pUrls"
                      :p-error-list="pErrorList"
                      :p-src="pSrc"
                      :p-src-id="pSrcId"
                      p-input-name="dataForm.data.marketIds"
                      p-error-key="dataForm.data.marketIds"
                      p-select-container="#marketDropdownMenu"
                      :p-required="false"
                      :p-disabled="false">
                  </market-select>
                </form>
              </div>
            </div>
            <div class="col-xs-9 scroll-y" style="height: calc(65vh - 60px);">
              <div class="bs3-padding-y">
                <div v-if="loading" class="loading bs3-margin-bottom"><i class="fa-light fa-spinner fa-spin" aria-hidden="true"></i>
                  {{ pDictionary['dictionary.general.loading'] }}
                </div>
                <div v-else-if="!mediaFormatList.length" class="emptyOrNull bs3-margin-bottom">
                  {{ pDictionary['dictionary.general.none'] }}
                </div>
                <table v-else class="table">
                  <thead>
                  <tr>
                    <th></th>
                    <th>{{ pDictionary['dictionary.media'] }}</th>
                    <th>{{ pDictionary['dictionary.media.format'] }}</th>
                    <th>{{ pDictionary['dictionary.media.format.specification'] }}</th>
                    <th>{{ pDictionary['dictionary.media.format.cost'] }}</th>
                  </tr>
                  </thead>
                  <tbody>
                  <tr v-for="mediaFormat in mediaFormatList" :key="mediaFormat.id">
                    <td><input type="checkbox" :value="mediaFormat.id" v-model="mediaFormatIds"/></td>
                    <td>{{ mediaFormat.mediaRef.name }}</td>
                    <td>{{ mediaFormat.name }}</td>
                    <td v-html="mediaFormat.defaultSpecification"></td>
                    <td class="text-nowrap">{{ getRate(mediaFormat) | money(pCurrencies, pCurrencyId) }}</td>
                  </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
        <div class="panel-footer text-right">
          <button @click.prevent="addMediaFormat" class="btn btn-default"><i class="fa-light fa-plus"></i> {{ pDictionary['dictionary.actions.add'] }}</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import MediaExtraInfoSelect from "@/components/media/MediaExtraInfoSelect";
import MarketSelect from "@/components/modules/administration-module/market/MarketSelect";

import stringhelpers from "@/helpers/string-helpers";
import MediaCategorySelect from "@/components/modules/media-module/media-category/MediaCategorySelect";

export default {
  name: "MediaFormatAdvancedPicker",
  components: {MediaCategorySelect, MediaExtraInfoSelect, MarketSelect},
  props: {
    pCurrencies: Array,
    pCurrencyId: Number,
    pLanguage: String,
    pDictionary: Object,
    pUrls: Object,
    pErrorList: {
      type: Object,
      default: function () {
        return {}
      }
    },
    pSrc: String,
    pSrcId: String,
    pMediaRateCardId: Number,
    pMediaExtraInfo1Enabled: {
      type: Boolean,
      default: function () {
        return false
      }
    },
    pMediaExtraInfo2Enabled: {
      type: Boolean,
      default: function () {
        return false
      }
    }
  },
  data: function () {
    return {
      loading: true,
      mediaFormatList: [],
      search: '',
      mediaIds: [],
      mediaCategoryIds: [],
      mediaFormatIds: [],
      marketIds: [-1],
      mediaExtraInfo1Values: [''],
      mediaExtraInfo2Values: ['']
    }
  },
  methods: {
    reset: function () {
      this.mediaFormatList = [];
      this.search = '';
      this.mediaCategoryIds = [-1];
      this.mediaFormatIds = [];
      this.marketIds = [-1];
      this.mediaExtraInfo1Values = [''];
      this.mediaExtraInfo2Values = [''];
    },
    addMediaFormat: function () {
      let _component = this;
      this.$emit('media-format-selected', this.mediaFormatIds);
      $(_component.$refs.mediaFormatDropdownButton).dropdown('toggle');
    },
    refreshMediaFormatList: function () {
      let _component = this;
      _component.loading = true;
      $.ajax({
               type: "POST",
               url: '/mediaplan/app/endpoints/json-api/medias/formats',
               data: JSON.stringify({
                                      searchKeyword: _component.search,
                                      mediaCategoryIds: _component.mediaCategoryIds,
                                      mediaExtraInfo1Values: _component.mediaExtraInfo1Values,
                                      mediaExtraInfo2Values: _component.mediaExtraInfo2Values,
                                      marketIds: _component.marketIds
                                    }),
               headers: {
                 'Accept': 'application/json',
                 'Content-Type': 'application/json'
               }
             }).done(function (mediaFormatList) {
        _component.loading = false;
        _component.mediaFormatList = mediaFormatList.filter(mf => _component.getRate(mf));
      });
    },
    getRate: function(mediaFormat) {
      let rate;
      if(this.pMediaRateCardId) {
        let mediaFormatRateCard = mediaFormat.ratesByRateCardId[this.pMediaRateCardId];
        if(mediaFormatRateCard) {
          rate = mediaFormatRateCard.rateText;
        }
      }
      if(!rate) {
        rate = mediaFormat.defaultRate;
      }
      return rate;
    },
    onEnter: function() {

    }
  },
  watch: {
    search: function () {
      this.refreshMediaFormatList();
    },
    mediaCategoryIds: function () {
      this.refreshMediaFormatList();
    },
    mediaExtraInfo1Values: function () {
      this.refreshMediaFormatList();
    },
    mediaExtraInfo2Values: function () {
      this.refreshMediaFormatList();
    },
    marketIds: function () {
      this.refreshMediaFormatList();
    }
  },
  filters: {
    // TODO: Use mixin...
    safeReference: function (reference, dictionary, index) {
      if(!reference)
      {
        return dictionary['dictionary.proposal'] + index;
      }
      return reference;
    },
    i18nparams: function (text, index, param) {
      if(!text)
      {
        return text;
      }
      else
      {
        return stringhelpers.replaceAll(text, '__' + index + '__', param);
      }
    },
    money: function (value, currencies, currencyId) {
      if(value) {
        let currency = currencies.find(c => c.id === currencyId);
        if(currency) {
          if(currency.symbolPosition === 'BEFORE') {
            return currency.symbol + " " + value;
          }
          return value + " " + currency.symbol;
        }
      }
      return '-';
    },
    percent: function (value, dictionary) {
      if(!value)
      {
        return '-';
      }
      else
      {
        let percentFormat = dictionary['dictionary.format.percent.digit.4'];
        return stringhelpers.replaceAll(percentFormat, '__0__', value);
      }
    },
    error: function (value, dictionary) {
      if(!value)
      {
        return '-';
      }
      else
      {
        let errorFormat = dictionary['dictionary.general.errors'];
        return stringhelpers.replaceAll(errorFormat, '__0__', value);
      }
    }
  },
  mounted: function () {
    let _component = this;
    $(_component.$refs.mediaFormatDropdownButtonGroup).on('show.bs.dropdown', function () {
      _component.$emit('media-format-select-open');
      _component.reset();
      _component.refreshMediaFormatList();
    });

    $(_component.$refs.mediaFormatDropdownButtonGroup).on('shown.bs.dropdown', function () {
      _component.$refs.search.focus();
    });

    $(_component.$refs.mediaFormatDropdownMenu).on("click.bs.dropdown", function (e) {
      e.stopPropagation();
    });

    $(_component.$refs.mediaFormatDropdownButtonGroup).on('hide.bs.dropdown', function () {
      _component.$emit('media-format-select-close');
    });
  }
}
</script>

<style scoped>

</style>